import React from 'react'
import PropTypes from 'prop-types'

import './ButtonGroup.scss'

import { CButtonGroup, CButton } from '@coreui/react-pro'

const ButtonGroup = ({ value, selected, onChange, error, disabled }) => {
  return (
    <CButtonGroup className={`${error ? 'error' : ''}`} role="group">
      {value.map((item) => (
        <CButton
          onClick={() => onChange(item)}
          className="group-button"
          active={selected === item}
          key={item}
          disabled={disabled}
          color={selected === item ? 'primary' : 'secondary'}
        >
          {item}
        </CButton>
      ))}
    </CButtonGroup>
  )
}

ButtonGroup.propTypes = {
  value: PropTypes.array,
  disabled: PropTypes.bool,
  selected: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.bool,
}

export default ButtonGroup
